<template>
  <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect y="2" width="12" height="2" rx="1" fill="currentColor"/>
    <rect y="7" width="12" height="2" rx="1" fill="currentColor"/>
    <rect y="12" width="12" height="2" rx="1" fill="currentColor"/>
  </svg>
</template>